import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { IAdditionalDriver } from "../../classes/Domain";

let rules = {
    driver: {
        licenseNumber: [{ required_if: ['status', 'ADD'] }],
        licenseState: [{ required_if: ['status', 'ADD'] }],
        birthDate: [{ required_if: ['status', 'ADD'] }]
    },
    excludeReason: [{ required_if: ['status', 'EXCLUDE'] }],
    disregardReason: [{ required_if: ['status', 'DISREGARD'] }],
    representedDriverId: [{ required_if: ['status', 'REPRESENTED'] }]
};

export const allFieldsValidation = (data: IAdditionalDriver) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};